<template>
    <div>
        <div class="tabs" style="margin-top: -20px;">
            <!-- <el-tabs v-model="activeName" @tab-click="handleClick" >
                <el-tab-pane label="设备点检" v-if='permission.btn_inspectionConfig_getDetai' name="device"></el-tab-pane>
                <el-tab-pane label="工具点检" v-if='permission.btn_toolInspectConfig_list' name="tool"></el-tab-pane>
            </el-tabs> -->
            <deviceInspect v-if="activeName=='device'"></deviceInspect>
            <!-- <toolInspect v-if="activeName=='tool'"></toolInspect> -->
        </div>
    </div>
</template>


<script>
    import deviceInspect from './CheckConf.vue'
    import toolInspect from './ToolInspectConfig.vue'
    export default {
        name:'BaseInspect',
        data() {
            return {
                activeName:'device',
                permission:JSON.parse(localStorage.getItem("permission")) 
            }
        },
        mounted(){
            //当设备工单权限不存在并且工具工单权限存在是默认选中工具
            // if(!this.permission.btn_inspectionConfig_getDetai&&this.permission.btn_toolInspectConfig_list){
            //     this.activeName = 'tool'
            // }
        },
        components: {
            deviceInspect,
            toolInspect
        },
        methods: {
            handleClick(tab, event) {
                this.activeName = tab.name
            }
        }
    }
</script>

<style scoped>
    .delete{
        width: 18px;
        height: 19px;
        background-image:url('../../../static/img/del.png');
        cursor: pointer;
        background-repeat: no-repeat;
    }
    .delete:hover{

        background-image: url('../../../static/img/del-hover.png');
        background-repeat: no-repeat;
    }
    .table_searchbar .title11{
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
    }
    .add_form .title{
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
        display:inline-block;
        text-align: right;
        width: 70px;
    }
    .add_form .value{
        display:inline-block
    }
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }

    .table_searchbar{
        width:100%;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .import_upload{
        display: inline;
    }
    .page{
        display: flex;
        justify-content: flex-end;
    }
    @media screen and (max-width: 1380px){
        .page{
            display: flex;
            justify-content: flex-end;
            margin-bottom:30px;
        }
    }
    .total_page{
        margin-top: 20px;
        margin-right: 26px;
        color:#606266;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/views/devicecare/BaseInspectConfig.vue